import React, { useEffect } from "react";
import { connect } from "react-redux";
import CartCard from "../components/Shop/CartCard/CartCard";
import * as shopActions from "./../actions/shop";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router";
import TotalSum from "../components/Shop/TotalSum/TotalSum";
import ConfirmationButton from "../components/Shop/ConfirmationButton/ConfirmationButton";
import { useTranslation } from "react-i18next";
import "./scss/Cart.scss";
import "react-notifications/lib/notifications.css";
import DeliveryDate from "../components/DeliveryDate/DeliveryDate";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

const Cart = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  document.title = `Gudema - ${t("cartPage.title")}`;

  const { getCart } = props;

  useEffect(() => {
    getCart(history);
  }, [getCart, history]);

  const submitOrderHandler = async ({ message }) => {
    const res = await props.submitOrder();

    if (res && res === true) {
      NotificationManager.success(message);
    } else if (res && res === "error") {
      NotificationManager.error(t("cartPage.error"));
    }
  };

  return (
    <main className="cart-page">
      <NotificationContainer />

      <div className="cart-page__container">
        {props.ordered ? (
          <div className="cart-page__confirmed-head">
            <h1>{t("cartPage.confirmedTitle")}</h1>

            <p>
              {t("cartPage.confirmedText")} {" "}
              <a href="tel:+37067362767">+370 673 62 767</a>.
            </p>
          </div>
        ) : (
          <div className="cart-page__head">
            <h1>{t("cartPage.title")}</h1>

            <DeliveryDate className="cart-page__delivery-date" />
          </div>
        )}

        {props.cart && props.cart.length ? (
          <>
            <div className="cart-table">
              <div className="cart-table__head">
                <div>{t("cartPage.product")}</div>
                <div>{t("cartPage.productInfo")}</div>
                <div>{t("cartPage.deliveryDate")}</div>
                <div>{t("cartPage.quantity")}</div>
                <div>{t("cartPage.total")}</div>
              </div>

              {props.cart.map((item, i) => (
                <CartCard key={i} item={item} date={props.date} />
              ))}
            </div>

            {!props.ordered ? (
              <div className="cart-page__bottom">
                <button
                  type="button"
                  className="cart-page__back"
                  onClick={() => history.push("/shop")}
                >
                  <span>←</span>
                  {t("cartPage.back")}
                </button>

                <div className="cart-page__summary">
                  <TotalSum cart={props.cart} />

                  <ConfirmationButton
                    submitOrderHandler={submitOrderHandler.bind(this, {
                      message: t("message.orderConfNotif.message"),
                    })}
                    ordered={props.ordered}
                  />
                </div>
              </div>
            ) : null}
          </>
        ) : (
          <div className="cart-page__empty">
            <p>{t("cartPage.empty")}</p>

            <button type="button" onClick={() => history.push("/shop")}>
              {t("cartPage.backToShop")}
            </button>
          </div>
        )}
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  cart: state.shop.cart,
  cartTemp: state.shop.cartTemp,
  flowers: state.flowers.items,
  ordered: state.shop.ordered,
  dates: state.shop.dates,
  date: state.shop.date,
  dateSelect: state.shop.dateSelect,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(shopActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
